<template>
  <div class="dashboard"></div>
</template>

<script>
    export default {
        name: "Dashboard",
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
